/*
 * nf-popup — modal estilo Apple (estructura BaseModal medida vía CDP en
 * apple.com/mac/?focus=built-for-ai y apple.com/store, jul-2026).
 *
 * Claves de la réplica:
 *  · El OVERLAY es el scroll-container (fixed inset:0 overflow-y:auto): la barra
 *    de scroll aparece pegada al borde de la VENTANA, nunca dentro del card.
 *  · El card NO tiene overflow propio (crece lo que necesite; centrado con
 *    margin:auto en flex — si excede el viewport, se scrollea completo).
 *  · TRES variantes AISLADAS entre sí (cambiar una NO afecta a las otras):
 *      --vp   (Value Prop): diseño "quicklook" original independiente — card 600px,
 *        imagen full-bleed arriba + bloque de texto (eyebrow+título+body). compose()
 *        devuelve el contenido crudo tal cual. Trigger: data-nf-popup-variant="valueprop".
 *      --bleed (Feature/Full-bleed): overlay rgba(0,0,0,.48) + blur(20px); card ancho,
 *        contenido en "tiles folleto" grises #f6f4f1 (título two-tone + imagen). Default.
 *      --copy (Apple Icon + Copy): overlay SIN blur; card angosto de texto centrado.
 *        Trigger: data-nf-popup-variant="copy".
 *    ⚠️ Value Prop y Feature YA NO comparten estilos (antes ambos usaban bleed).
 *  · Cierre X 36px sticky (como Apple), backdrop o Esc. Bloqueo de scroll del
 *    documento con compensación del ancho de scrollbar (sin salto de layout).
 *
 * El contenido vive oculto dentro de cada tarjeta en `.nf-fg__popup`; al abrir
 * se recompone dentro del modal compartido. Variante vía data-nf-popup-variant
 * en el trigger (default: bleed).
 */
(function () {
  if (window.__nfPopupInit) return;
  window.__nfPopupInit = true;

  var STYLE =
    /* Overlay = scroll container (patrón Apple BaseModal_modalOverlay) */
    '.nf-popup-overlay{position:fixed;inset:0;z-index:11000;display:none;align-items:flex-start;overflow-y:auto;overflow-x:hidden;' +
    'background:rgba(0,0,0,0.48);opacity:0;transition:opacity .32s cubic-bezier(.4,0,.6,1);-webkit-overflow-scrolling:touch;}' +
    '.nf-popup-overlay.nf-popup--bleed{-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);}' +
    '.nf-popup-overlay.is-open{display:flex;opacity:1;}' +
    /* Card: sin overflow propio; margin auto = centrado + scroll completo si excede */
    '.nf-popup-panel{position:relative;margin:48px auto;background:#fff;border-radius:28px;' +
    'box-shadow:0 30px 80px rgba(10,14,22,0.4);transform:translateY(18px) scale(.985);opacity:0;' +
    'transition:transform .32s cubic-bezier(.16,1,.3,1),opacity .32s ease;}' +
    '.nf-popup--bleed .nf-popup-panel{width:min(92vw,1260px);padding:clamp(24px,6vw,76px);}' +
    '.nf-popup--copy .nf-popup-panel{width:min(87.5vw,640px);padding:20px;}' +
    '.nf-popup-overlay.is-open .nf-popup-panel{transform:none;opacity:1;}' +
    /* Cierre estilo Apple: 36px, sticky top, gris #e6e2dc */
    '.nf-popup-close{position:sticky;top:20px;float:right;z-index:2;width:36px;height:36px;border:none;border-radius:50%;' +
    'cursor:pointer;background:#e6e2dc;color:#1a253a;display:inline-flex;align-items:center;justify-content:center;transition:background .2s ease;}' +
    '.nf-popup-close:hover{background:#dcdce1;}' +
    '.nf-popup-close svg{width:16px;height:16px;}' +
    /* FOLLETO Apple (variante bleed, EXCLUSIVA de Feature): header (eyebrow+título) +
       tiles grises apilados; cada tile = copy grande + media (imagen real o placeholder
       con espacio reservado). Medidas del DeepLinkModal de apple.com (jul-2026). */
    '.nf-pop-brochure{font-family:var(--premium-font-body);}' +
    '.nf-pop-head{max-width:830px;margin:0 0 28px;padding:0;}' +
    '.nf-pop-head__eyebrow{font-family:var(--premium-font-heading);font-size:15px;font-weight:600;letter-spacing:.01em;color:var(--nf-pop-accent,#1a253a);margin:0 0 8px;}' +
    '.nf-pop-head__title{font-family:var(--premium-font-heading);font-size:clamp(28px,4vw,44px);font-weight:600;line-height:1.08;letter-spacing:-0.02em;color:#1a253a;margin:0;}' +
    '.nf-pop-tiles{display:flex;flex-direction:column;gap:20px;clear:both;font-family:var(--premium-font-body);}' +
    '.nf-pop-tile{background:#f6f4f1;border-radius:28px;padding:0;overflow:hidden;}' +
    /* copy con padding (copy space arriba); la imagen NO tiene padding = full-bleed a bordes */
    '.nf-pop-tile__copy{max-width:848px;margin:0;padding:clamp(30px,4vw,52px) clamp(24px,3.5vw,56px) clamp(20px,2.6vw,32px);font-family:var(--premium-font-heading);' +
    'font-size:clamp(21px,2.2vw,28px);font-weight:600;line-height:1.28;letter-spacing:-0.015em;color:#5b6474;}' +
    '.nf-pop-tile__copy strong,.nf-pop-tile__copy b{color:#1a253a;font-weight:600;}' +
    '.nf-pop-tile__copy .t-muted{color:#5b6474;}' +
    /* imagen pegada a izq/der/abajo (el fondo del tile #f6f4f1 se funde con imágenes de fondo gris = efecto flotante) */
    '.nf-pop-tile__media{display:block;width:100%;margin:0;}' +
    '.nf-pop-tile__media img{display:block;width:100%;height:auto;}' +
    '.nf-pop-tile__media--ph{height:clamp(220px,28vw,380px);background:#ececf0;border-top:1px dashed #c7c7d0;display:flex;align-items:center;justify-content:center;}' +
    '.nf-pop-tile__media--ph span{font-family:var(--premium-font-body);font-size:14px;font-weight:600;color:#9a9aa2;letter-spacing:.02em;}' +
    /* Variante copy: puro texto centrado */
    '.nf-pop-copy{clear:both;padding:8px clamp(8px,3vw,28px) 20px;text-align:center;font-family:var(--premium-font-body);}' +
    '.nf-pop-copy .nf-pop__eyebrow{font-family:var(--premium-font-heading);font-size:12px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--nf-pop-accent,#1a253a);margin:0 0 12px;}' +
    '.nf-pop-copy .nf-pop__title{font-family:var(--premium-font-heading);font-size:clamp(24px,3vw,32px);font-weight:600;line-height:1.15;letter-spacing:-0.02em;color:#1a253a;margin:0 0 16px;}' +
    '.nf-pop-copy .nf-pop__body{font-size:17px;line-height:1.6;color:#494f57;margin:0;}' +
    '.nf-pop-copy .nf-pop__body p{margin:0 0 12px;}' +
    /* Variante VALUE PROP (--vp): AISLADA de bleed/copy. Diseño original "quicklook":
       imagen arriba (full-bleed) + bloque de texto (eyebrow+título+body). Card 600px.
       NO comparte estilos con Feature (bleed) ni Icon+Copy (copy). */
    '.nf-popup-overlay.nf-popup--vp{-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);}' +
    '.nf-popup--vp .nf-popup-panel{width:min(92vw,600px);padding:0;overflow:hidden;}' +
    /* Centrado vertical: margin:auto en el flex container centra la tarjeta en la
       ventana; si es más alta que la pantalla, los auto-margins quedan en 0 y se
       scrollea completa (el padding del overlay deja aire arriba y abajo). */
    '.nf-popup-overlay.nf-popup--vp{padding:24px 0;}' +
    '.nf-popup--vp .nf-popup-panel{margin:auto;}' +
    '.nf-popup--vp .nf-popup-close{position:absolute;top:14px;right:14px;float:none;background:rgba(255,255,255,0.85);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);box-shadow:0 2px 10px rgba(10,14,22,0.18);}' +
    '.nf-popup--vp .nf-pop__img{display:block;width:100%;height:auto;background:#faf8f5;}' +
    '.nf-popup--vp .nf-pop__text{padding:40px;font-family:var(--premium-font-body);}' +
    '.nf-popup--vp .nf-pop__eyebrow{font-family:var(--premium-font-heading);font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--nf-pop-accent,#1a253a);margin:0 0 10px;}' +
    '.nf-popup--vp .nf-pop__title{font-family:var(--premium-font-heading);font-size:28px;font-weight:600;line-height:1.12;letter-spacing:-0.02em;color:#1a253a;margin:0 0 14px;}' +
    '.nf-popup--vp .nf-pop__body{font-size:17px;line-height:1.6;color:#543a32;margin:0;}' +
    '.nf-popup--vp .nf-pop__body p{margin:0 0 12px;}' +
    '@media (max-width:600px){.nf-popup--vp .nf-pop__text{padding:28px 24px 32px;}.nf-popup--vp .nf-pop__title{font-size:24px;}}' +
    /* CTA (ambas variantes): botón primario del sistema */
    '.nf-pop__cta{display:inline-flex;align-items:center;justify-content:center;margin-top:24px;min-height:44px;padding:11px 21px;' +
    'border-radius:980px;background:#1a253a;color:#fff;font-family:var(--premium-font-body);font-weight:400;font-size:17px;text-decoration:none;transition:filter .15s ease;}' +
    '.nf-pop__cta:hover{filter:brightness(0.93);}' +
    '.nf-pop-tiles .nf-pop__cta{align-self:flex-start;}' +
    '@media (max-width:749px){.nf-popup-panel{margin:20px auto;}.nf-pop__cta{min-height:36px;padding:8px 16px;font-size:14px;}}' +
    '@media (prefers-reduced-motion: reduce){.nf-popup-overlay,.nf-popup-panel{transition:none;}}';

  var overlay, panel, body, lastFocus;

  function build() {
    var s = document.createElement('style');
    s.textContent = STYLE;
    document.head.appendChild(s);

    overlay = document.createElement('div');
    overlay.className = 'nf-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="nf-popup-panel">' +
      '<button type="button" class="nf-popup-close" aria-label="Cerrar">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button><div class="nf-popup-body"></div></div>';
    document.body.appendChild(overlay);
    panel = overlay.querySelector('.nf-popup-panel');
    body = overlay.querySelector('.nf-popup-body');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.nf-popup-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
  }

  /* Recompone el contenido crudo de .nf-fg__popup según la variante */
  function compose(raw, variant) {
    /* VALUE PROP: diseño original independiente — se renderiza el contenido crudo
       de .nf-fg__popup (imagen + .nf-pop__text) tal cual, estilado por .nf-popup--vp.
       No pasa por la recomposición en tiles (bleed) ni copy. */
    if (variant === 'valueprop') return raw;
    var tmp = document.createElement('div');
    tmp.innerHTML = raw;
    var img = tmp.querySelector('.nf-pop__img');
    var eyebrow = tmp.querySelector('.nf-pop__eyebrow');
    var title = tmp.querySelector('.nf-pop__title');
    var bodyEl = tmp.querySelector('.nf-pop__body');
    var cta = tmp.querySelector('.nf-pop__cta');
    var esc = function (el) { return el ? el.innerHTML : ''; };

    if (variant === 'copy') {
      return '<div class="nf-pop-copy">' +
        (eyebrow ? '<p class="nf-pop__eyebrow">' + esc(eyebrow) + '</p>' : '') +
        (title ? '<h3 class="nf-pop__title">' + esc(title) + '</h3>' : '') +
        (bodyEl ? '<div class="nf-pop__body">' + esc(bodyEl) + '</div>' : '') +
        (cta ? '<a class="nf-pop__cta" href="' + (cta.getAttribute('href') || '#') + '">' + cta.textContent + '</a>' : '') +
        '</div>';
    }

    /* bleed (Feature): FOLLETO Apple — header (eyebrow+título) fuera de los tiles +
       tiles apilados; cada párrafo del body = una tile (copy arriba + imagen full-bleed
       pegada a los bordes izq/der/abajo). NUNCA se usa la imagen de la tarjeta: cada tile
       tiene su propia imagen (.nf-pop__tileimgs img[i]). Sin imagen → placeholder. */
    /* Un hijo por tile (img o <span data-empty>) para que la imagen 3 nunca caiga
       en la tile 1 si falta la 1. El hueco gris solo se ve en el editor del tema. */
    var tileImgs = [].slice.call(tmp.querySelectorAll('.nf-pop__tileimgs > *')).map(function (el) { return el.tagName === 'IMG' ? el : null; });
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var paras = [];
    if (bodyEl) {
      var ps = bodyEl.querySelectorAll('p');
      if (ps.length) { ps.forEach(function (p) { if (p.textContent.trim()) paras.push(p.innerHTML); }); }
      else if (bodyEl.textContent.trim()) { paras.push(bodyEl.innerHTML); }
    }
    var head = '<div class="nf-pop-head">' +
      (eyebrow ? '<p class="nf-pop-head__eyebrow">' + eyebrow.textContent.trim() + '</p>' : '') +
      (title ? '<h3 class="nf-pop-head__title">' + title.textContent.trim() + '</h3>' : '') +
      '</div>';
    var tiles = '';
    paras.forEach(function (html, i) {
      var im = tileImgs[i];
      var media = im
        ? '<figure class="nf-pop-tile__media">' + im.outerHTML.replace(/\sclass="[^"]*"/, '') + '</figure>'
        : (designMode ? '<div class="nf-pop-tile__media nf-pop-tile__media--ph" aria-hidden="true"><span>Imagen (opcional)</span></div>' : '');
      tiles += '<div class="nf-pop-tile"><p class="nf-pop-tile__copy">' + html + '</p>' + media + '</div>';
    });
    return '<div class="nf-pop-brochure">' + head +
      (tiles ? '<div class="nf-pop-tiles">' + tiles + '</div>' : '') +
      (cta ? '<a class="nf-pop__cta" href="' + (cta.getAttribute('href') || '#') + '">' + cta.textContent + '</a>' : '') +
      '</div>';
  }

  function open(content, accent, variant) {
    if (!overlay) build();
    overlay.classList.remove('nf-popup--bleed', 'nf-popup--copy', 'nf-popup--vp');
    overlay.classList.add(variant === 'copy' ? 'nf-popup--copy' : (variant === 'valueprop' ? 'nf-popup--vp' : 'nf-popup--bleed'));
    body.innerHTML = compose(content, variant);
    panel.style.setProperty('--nf-pop-accent', accent || '#1a253a');
    lastFocus = document.activeElement;
    /* Bloquear el scroll del documento compensando el ancho de la scrollbar (sin salto) */
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (sw > 0) document.documentElement.style.paddingRight = sw + 'px';
    overlay.classList.add('is-open');
    overlay.scrollTop = 0;
    var c = overlay.querySelector('.nf-popup-close'); if (c) c.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onTrigger(e) {
    var trigger = e.target.closest('[data-nf-popup]');
    if (!trigger) return;
    var card = trigger.closest('.nf-fg__card');
    if (!card) return;
    var data = card.querySelector('.nf-fg__popup');
    if (!data) return;
    e.preventDefault();
    var accent = getComputedStyle(card).getPropertyValue('--fg-accent') || '#1a253a';
    var variant = trigger.getAttribute('data-nf-popup-variant') || card.getAttribute('data-nf-popup-variant') || 'bleed';
    open(data.innerHTML, accent.trim(), variant);
  }

  document.addEventListener('click', onTrigger);
})();
